import { AfterViewInit, Component } from '@angular/core';
import { CookieService } from './shared/cookies/cookie.service';
import { RouteTitleService } from './common/route-title.service';
import { TelemetryService } from './common/telemetry.service';
import { NavigationEnd, Router } from '@angular/router';
import { AppViewMode, SettingsService } from './common/settings.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements AfterViewInit {
  title = 'kyudo-apps';

  constructor(
    private routeTitleService: RouteTitleService,
    private cookieService: CookieService,
    private router: Router,
    private telemetryService: TelemetryService,
    private settingsService: SettingsService
  ) {
    this.routeTitleService.init();

    if (
      this.settingsService.settings.viewMode === AppViewMode.BUILDER ||
      this.settingsService.settings.viewMode === AppViewMode.PREVIEW
    ) {
      // Initialize telemetry only for builder and preview modes
      this.telemetryService.init();
    }
  }

  ngOnInit() {
    // Track route changes
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.telemetryService.trackPageView(event.urlAfterRedirects);
      }
    });
  }

  ngAfterViewInit(): void {
    this.cookieService.init();
  }
}
